import classNames from 'classnames/bind';
import { TripType, useSearchParamsContext } from 'contexts/searchParams';
import React from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  index: number;
  tripType?: TripType;
  clickCodePrefix: string;
}

export default function Swap({
  className,
  index,
  tripType,
  clickCodePrefix,
}: IProps) {
  const { setSearchParams } = useSearchParamsContext();

  function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    if (tripType === TripType.RT) {
      setSearchParams(prev => {
        const [prev0, prev1] = prev.itinerary;
        const { departureCity, arrivalCity } = prev0;
        return {
          ...prev,
          itinerary: [
            {
              ...prev0,
              departureCity: arrivalCity,
              arrivalCity: departureCity,
            },
            {
              ...prev1,
              departureCity,
              arrivalCity,
            },
          ],
        };
      });
      return;
    }

    setSearchParams(prev => {
      const { departureCity, arrivalCity, departureDate } =
        prev.itinerary[index];
      if (!(departureCity && arrivalCity)) return prev;
      return {
        ...prev,
        itinerary: [
          ...prev.itinerary.slice(0, index),
          {
            departureCity: arrivalCity,
            arrivalCity: departureCity,
            departureDate,
          },
          ...prev.itinerary.slice(index + 1),
        ],
      };
    });
  }

  return (
    <button
      type="button"
      className={cx(className, 'Swap')}
      title="출도착지 전환"
      aria-label="출도착지 전환"
      data-event-nlog="click"
      data-event-area-code={`${clickCodePrefix}.switch${index + 1}`}
      onClick={handleClick}
    />
  );
}
